import { apiClient, extractApiError } from './api';
import { SupportTicket, TicketStatus, ApiResponse } from '@/types';

class SupportService {
  /**
   * Get user tickets
   */
  async getTickets(params?: { status?: TicketStatus[] }): Promise<{ tickets: SupportTicket[], total: number }> {
    try {
      const response = await apiClient.get<ApiResponse<{ tickets: SupportTicket[], total: number }>>('/support/tickets', { params });
      return response.data.data || { tickets: [], total: 0 };
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Get ticket details
   */
  async getTicketDetail(id: string): Promise<SupportTicket> {
    try {
      const response = await apiClient.get<ApiResponse<SupportTicket>>(`/support/tickets/${id}`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Create new ticket (with attachment support)
   */
  async createTicket(data: FormData): Promise<SupportTicket> {
    try {
       const response = await apiClient.post<ApiResponse<SupportTicket>>('/support/tickets', data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }

  /**
   * Close ticket
   */
  async closeTicket(id: string): Promise<SupportTicket> {
    try {
      const response = await apiClient.put<ApiResponse<SupportTicket>>(`/support/tickets/${id}/close`);
      return response.data.data!;
    } catch (error) {
      throw extractApiError(error);
    }
  }
}

export const supportService = new SupportService();
export default supportService;
